import * as React from "react";
import {observer, inject} from "mobx-react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
//import { CSSTransition } from 'react-transition-group';
import Modal from "../react-responsive-modal/modal";

export class ToolbarSection extends React.Component {

    constructor(props) {
        super(props);

        this.elementRef = React.createRef();
    }


    preventDefault(e) {
        e.preventDefault();
    }

    componentDidMount() {
        //this.targetElement = document.querySelector('#toolbarSection');
        //console.debug("disableBodyScroll", this.targetElement, this.modal);
        //disableBodyScroll(this.targetElement, { reserveScrollBarGap: true });
        
    
        //this.elementRef.current.addEventListener('pointermove', this.preventDefault);
        
    }

    componentWillUnmount() {
        //this.elementRef.current.addEventListener('pointermove', this.preventDefault);
        //clearAllBodyScrollLocks();
    }


    render() {
        this.hasFooter = this.props.hasFooter || false;
        const classes = [
            "toolbar-section",
            "current",
            this.props.className
        ];

        return (
            <div className={classes.join(' ')} ref={this.elementRef}

                 onScroll={(e) => {
                     console.debug("onScroll");
                     e.preventDefault();
                     
                 }}
                  onTouchMove={(e) => {
                      console.debug("onTouchMove");
                      e.preventDefault();
                      e.stopPropagation();
                  }}
                  onTouchStart={(e) => {
                      var element = this.elementRef.current;
                      var top = element.scrollTop, totalScroll = element.scrollHeight, currentScroll = top + element.offsetHeight;
                      console.debug("onTouchStart");
                      // prevent swipe to navigate back gesture
                      e.preventDefault();
                      //
                      // if (top === 0) {
                      //     //console.debug("onTouchStart", element, element.scrollTop);
                      //     element.scrollTop = 1;
                      // } else if (currentScroll === totalScroll) {
                      //     //console.debug("onTouchStart");
                      //     element.scrollTop = top - 1;
                      // }
                 
                  }}

            >
                {this.props.children}
            </div>
        );
    }

}

@inject("store")
@observer
export class ToolbarDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.modalRef = React.createRef();
        this.state = {
            modalOpen: false
        };
    }
    

    close() {
        const navigation = this.props.store.navigation;
        navigation.closeToolbar(this.props.forceReplaceUrl || false);
    }
    
    
    //componentWillMount() {

    //}

    componentDidMount() {
        const navigation = this.props.store.navigation;
        navigation.setNavigationVisible(true);
        this.setState({modalOpen: true});
    }

    render() {
        const navigation = this.props.store.navigation;
        
        this.hasFooter = this.props.hasFooter || false;
        const classes = [
            "toolbar-dropdown",
            "open",
            this.props.wide ? "wide" : null,
            this.props.left ? "left" : null,
            this.hasFooter ? "has-footer" : null,
            this.props.hideHeader ? "no-header" : null,
            this.props.isNavigation ? "nav-background" : null,
            this.props.className,
        ];

        //console.debug("ToolbarDropdown render");

        return (
            <React.Fragment>
                <div ref={this.modalRef} className="rmd-modal-dialog">
                    <Modal
                        container={this.modalRef.current}
                        open={this.state.modalOpen}
                        onClose={(e) => {
                            //this.close(this.props.forceReplace)
                            navigation.closeToolbar(this.props.forceReplaceUrl || false);
                        }}
                        focusTrapped={false}
                        showCloseIcon={false}
                        scrollClass="scroll-content"
                        classNames={{
                            overlay: "dropdown-dialog",
                            modal: classes.join(' '),
                            closeIcon: "dropdown-dialog-closeIcon"
                        }}
                        animationDuration={0}
                        //blockScroll={navigation.isMobile}
                        blockScroll={false}
                    >
                        {this.props.hideHeader ? null :
                            <div className={"header"}>
                                
                                <div className="title" dangerouslySetInnerHTML={{__html: this.props.header}}></div>
                                {this.props.hideClose ? null :
                                    <div className="header-close" onClick={(e) => this.close()}>
                                        <FontAwesomeIcon icon={["fas", "times"]} className="close-big"/>
                                    </div>}
                            </div>}

                        {this.props.children}

                    </Modal>
                </div>
                {/*<div className="toolbar-background" onClick={(e) => this.close()}></div>*/}
            </React.Fragment>
        );
    }
}
